import apiClient from './apiClient';
import { GET_TOUR_PAX_TYPE_URL } from './apiUrl';

const getTourPaxTypeApi = () => {
  return apiClient.get(GET_TOUR_PAX_TYPE_URL);
};

export default getTourPaxTypeApi;
